import React from 'react';

const EVChargers = ({ language = 'en' }) => {
  const content = {
    en: {
      title: 'EV Charging & Payment System Solution',
      subtitle: 'EV Charging & Payment System',
      intro: [
        "We provide a one-stop EV charging management and automated payment solution tailored for Hong Kong's properties, commercial buildings, estates and car parks.",
        "Combining smart software, cloud technology and power management systems, we create a safe, stable and efficient charging service ecosystem. Our intelligent charging pile management platform features real-time monitoring, remote control, automatic settlement, data analysis and dynamic load balancing to optimise power distribution, prevent grid overload and improve the overall efficiency and reliability of charging stations, while delivering a convenient, transparent and intelligent charging experience for operators and users."
      ],
      features: {
        title: 'Key Features & Advantages',
        items: [
          'Centralised smart charging management platform supporting unified monitoring and control for multi-scenario and multi-device environments',
          'Dynamic load balancing technology to ensure stable power supply and avoid overload',
          'Real-time data monitoring, charging status tracking, anomaly alerts and remote troubleshooting',
          'Supports a wide range of payment methods, including Octopus, all major mobile payment services, and our custom-developed mobile application.',
          'Fully automated payment and settlement system with secure online payment support',
          'Comprehensive financial and operational data analysis to optimise management and increase revenue',
          'Suitable for commercial buildings, residential estates, private car parks and commercial facilities'
        ]
      }
    },
    zh: {
      title: '電動車充電及付款系統解決方案',
      subtitle: '電動車充電及付款系統',
      intro: [
        '我們專為香港物業、商廈、屋苑及停車場提供一站式電動車充電管理與自動付款解決方案，結合智能軟件、雲端技術與電力管理系統，打造安全、穩定、高效的充電服務生態。我們研發的智能充電樁管理平台具備實時監控、遙程控制、自動結算、數據分析及動態負載平衡功能，有效優化電力分配、防止電網過載，提升充電站整體運行效率與可靠性，同時為管理方與用戶帶來便捷、透明、智能化的充電體驗。'
      ],
      features: {
        title: '系統功能與優勢',
        items: [
          '智能充電樁集中管理平台，支援多場景、多設備統一監控與操作',
          '動態負載平衡技術（Load Balancing），確保電力穩定供應、避免過載',
          '實時數據監控、充電狀態查詢、異常告警與遠程故障診斷',
          '支援多種付款方法例如八達通、所有手機支付、以及由我們開發的手機應用程式等',
          '全自動付款結算系統，支援多元線上支付，交易安全即時',
          '詳盡財務與運營數據分析，協助物業優化管理、提升收益',
          '適用商廈、住宅屋苑、私人停車場、商業設施等多種場景'
        ]
      }
    }
  };

  const currentContent = content[language] || content.en;

  return (
    <section id="ev-chargers" className="service__section pt-120 pb-120">
      <div className="container">
        <div className="project__head text-center mb-60">
          <span className="common__sub aos-init aos-animate" data-aos="fade-down" data-aos-duration="1000">
            {currentContent.title}
          </span>
          <h2 className="fw-500 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200" style={{ color: '#c9f31d' }}>
            {currentContent.subtitle}
          </h2>
        </div>

        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          {/* Hero Image */}
          <div style={{ position: 'relative', zIndex: 1, borderRadius: '12px', overflow: 'hidden', marginBottom: '2rem' }}>
            <img
              src="/assets/photos/ev-charging.jpg"
              alt="EV Charging & Payment System"
              style={{ width: '100%', height: 'auto', display: 'block', borderRadius: '12px' }}
            />
          </div>
          {/* Intro */}
          <div
            className="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration="1000"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              padding: '2.5rem',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              marginBottom: '2rem',
              transition: 'all 0.3s ease'
            }}
          >
            {currentContent.intro.map((para, idx) => (
              <p key={idx} className="pra fz-18" style={{
                lineHeight: '1.9',
                color: '#e0e0e0',
                textAlign: 'justify',
                margin: idx < currentContent.intro.length - 1 ? '0 0 1rem 0' : '0'
              }}>
                {para}
              </p>
            ))}
          </div>

          {/* Features */}
          <div
            className="aos-init aos-animate"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              padding: '2.5rem',
              borderRadius: '12px',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              marginBottom: '2rem',
              transition: 'all 0.3s ease'
            }}
          >
            <h3 className="fz-24 fw-600 mb-3" style={{ color: '#c9f31d' }}>
              {currentContent.features.title}
            </h3>
            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
              {currentContent.features.items.map((item, idx) => (
                <li key={idx} className="pra fz-16 mb-2" style={{
                  paddingLeft: '1.5rem',
                  position: 'relative',
                  lineHeight: '1.7',
                  color: '#e0e0e0'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: '0',
                    color: '#c9f31d',
                    fontWeight: 'bold'
                  }}>•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EVChargers;
